import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import user from './modules/user';
import software from './modules/software';
import historyLogs from './modules/history-logs';
import printScreenshots from './modules/print-screenshots';
import logs from './modules/logs/index';
import filters from './modules/filters';
import pageSpecificData from './modules/page-specific-data';
import settings from './modules/settings';
import exportData from './modules/export-data';
import loader from './modules/loader';
import navigation from './modules/navigation';
import vnc from './modules/vnc';
import report from './modules/report';
import assistant from './modules/assistant';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    software,
    historyLogs,
    printScreenshots,
    logs,
    filters,
    pageSpecificData,
    settings,
    exportData,
    loader,
    navigation,
    vnc,
    report,
    assistant,
  },
  plugins: [
    createPersistedState({
      getState: (key, storage) => {
        const saved = JSON.parse(storage.getItem(key) || '{}');
        return saved.historyLogs ? { historyLogs: saved.historyLogs } : {};
      },
      reducer: (state) => ({
        historyLogs: state.historyLogs,
      }),
    }),
  ],
  actions: {
    init: (store) => store.dispatch('user/init'),
  },
});
